import React from "react";

export default function SecondaryButton({ children }) {
  return (
    <div className="px-8 w-fit p-1.5 text-xs font-semibold border border-slate-300 flex items-center justify-center text-slate-600 bg-white rounded-md shadow-md hover:brightness-110">
      {children}
    </div>
  );
}
